/* global axios */
import ApiClient from './ApiClient';

class CalendarAPI extends ApiClient {
  constructor() {
    super('calendar', { accountScoped: true });
  }

  getEvents(params) {
    return axios.get(`${this.url}/events`, { params });
  }

  getEventDetails(eventId) {
    return axios.get(`${this.url}/${eventId}/event_details`);
  }
}

export default new CalendarAPI();
